import React, { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

export const DeviceContext = createContext();

export const DeviceProvider = (props) => {
	const [deviceSession, setDeviceSession] = useState(
		Cookies.get("pisaraDevice") || null
	);

	const fetchDevice = async () => {
		const requestOptions = {
			headers: {
				method: "GET",
				"X-Device-Token": deviceSession,
			},
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/devices/me`,
			requestOptions
		);

		if (!response.ok) {
			setDeviceSession(null);
			return;
		}
		Cookies.set("pisaraDevice", deviceSession);
	};

	useEffect(() => {
		if (deviceSession) {
			fetchDevice();
		} else {
			Cookies.remove("pisaraDevice");
		}
	}, [deviceSession]);

	return (
		<DeviceContext.Provider value={[deviceSession, setDeviceSession]}>
			{props.children}
		</DeviceContext.Provider>
	);
};
